module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige10-99e255bcea53fb0f88b60dbcc4841d11.jpg";